import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';
import { VBox } from '../../../components/Box';
import { FormField } from '../../../components/FormFields';
import { Input } from '../../../components/Input';
import { Cell, List, Row } from '../../../components/List';
import { invoiceSearch } from "../actions";
import { BaseComponent } from "../../../components/BaseComponent";

const STATE = {
  string: '',
};

const Container = styled.div`
  .results {
    max-height: 60vh;
    overflow-y: auto;
    width: 100%;
  }
`;

/* eslint-disable react/prefer-stateless-function */
class InvoiceSelectionComp extends BaseComponent {
  constructor(props) {
    super(props, { ...STATE });
  }

  componentDidMount() {
    // setTimeout(
    //   this.onStringChange(
    //     {
    //       target: {
    //         value: 'comp',
    //       },
    //     },
    //     100,
    //   ),
    // );
  }

  onStringChange(evt) {
    let string = evt.target.value;
    this.setState({ string });
    this._t = this.timeout(this.search.bind(this), 300, this._t);
  }

  search() {
    // const search = normalizeSearchString(this.state.string);
    this.props.search(this.state.string, result =>
      this.setState({
        result: result.items
          ?.filter(invoice => invoice.id !== this.props.invoice?.id),
      }),
    );
  }

  render() {
    return (
      <Container>
        <VBox>
          <FormField>
            <Input name="string" onChange={this.onStringChange.bind(this)} value={this.state.string} />
          </FormField>
          {this.renderResult()}
        </VBox>
      </Container>
    );
  }

  renderResult() {
    if (!this.state.result) return '';

    return (
      <div className="results">
        <List>
          {this.state.result.map(invoice => (
            <Row key={invoice.id} onClick={() => this.props.onSelect?.(invoice)}>
              <Cell>{invoice.id}</Cell>
            </Row>
          ))}
        </List>
      </div>
    );
  }
}

InvoiceSelectionComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) => createStructuredSelector({});

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    search(string, callback) {
      dispatch(invoiceSearch(string, callback));
    },
  };
}

const withConnect = connect(
  mapStateToProps,
  mapDispatchToProps,
);

export const InvoiceSelection = compose(
  withConnect,
  withRouter,
)(InvoiceSelectionComp);
